import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BeyondSupplier } from 'src/app/model/beyond-supplier';

@Component({
  selector: 'app-terminate-beyond-supplier-dialog',
  templateUrl: './terminate-beyond-supplier-dialog.component.html',
  styleUrl: './terminate-beyond-supplier-dialog.component.scss'
})
export class TerminateBeyondSupplierDialogComponent {
  /** Row definitions to show beyond supplier information */
  public items: any[] = [
    {
      title: "ID",
      name: "primaryCompanyId",
    },
    {
      title: "Type", 
      name: "primaryCompanyType",
    },
    {
      title: "Name",
      name: "fullName",
    },
    {
      title: "Email",
      name: "email",
    },
    {
      title: "Group",
      name: "group",
    },
  ];

  /** The beyond supplier this class is verifying termination on */
  public beyondSupplier: any;

  /**
   * Default constructor initializes the component with a dialog ref
   * @param dialogRef
   */
  constructor(
    public dialogRef: MatDialogRef<TerminateBeyondSupplierDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {beyondSupplier: BeyondSupplier},
  ) {
    this.beyondSupplier = this.data?.beyondSupplier;
  }

  /**
   * Cancel the termination and close the dialog
   */
  public cancel() {
    this.dialogRef.close(false);
  }

  /**
   * Approve the termination and close the dialog
   */
  public terminate() {
    this.dialogRef.close(true);
  }
}
